var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"height":"auto","app":"","inset":""}},[_c('v-card',{staticClass:"white text-xs-center elevation-0",attrs:{"flat":"","tile":"","width":"100%"}},[(_vm.isMobileApp)?_c('mobile-menu'):_c('powered-by')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }